<template>
	<div>
		<div
			:class="[{ noborder: hideBorder }, size == 'lager' ? 'lagerStyle' : 'smallStyle']"
			v-if="!hideTitle"
			class="module-top"
		>
			<div class="module-top_body">
				<div>
					<span>{{ title }}</span>
					<span class="subtitle" v-if="subtitle">{{ subtitle }}</span>
					<el-tooltip placement="top" v-if="tipText">
						<div slot="content" class="tipcontent" v-html="tipText"></div>
						<ig-icon name="tishi" class="tipText"></ig-icon>
					</el-tooltip>
				</div>
			</div>
			<div
				:class="[{ noborder: hideBorder }, size == 'lager' ? 'top-detail' : 'top-smalldetail']"
				v-if="hidebutton && buttonName"
				@click="Detail()"
			>
				{{ buttonName }}
			</div>
			<div v-else class="headerRight">
				<slot name="headerRight"></slot>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		hideBorder: {
			type: Boolean,
		},
		hideTitle: {
			type: Boolean,
		},
		title: {
			type: String,
		},
		buttonName: {
			type: String,
		},
		buttonClick: {
			type: Function,
		},
		type: {
			type: String,
		},
		size: {
			type: String,
			default: 'lager',
		},
		subtitle: {
			type: String,
		},
		tipText: {
			type: String,
		},
		hidebutton: {
			type: Boolean,
			default: true,
		},
	},
	methods: {
		Detail() {
			if (typeof this.buttonClick == 'function') {
				return this.buttonClick();
			} else {
				return this.buttonClick;
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.lagerStyle {
	font-size: 16px;
	color: #333;
	font-weight: bold;
	height: 72px;
	padding: 0 20px;

	.tipText {
		font-weight: lighter !important;
		color: #c6c6c6;
		margin: 0 5px;
		font-size: 15px;
		cursor: pointer;
	}
}

.tipcontent {
	width: 350px;
	line-height: 20px;
	font-size: 12px;
}

.smallStyle {
	font-size: 14px;
	color: #333;
	font-weight: bold;
	height: 60px;
	padding: 0 20px;

	.tipText {
		font-weight: lighter !important;
		color: #c6c6c6;
		margin: 0 5px;
		font-size: 13px;
	}
}

.subtitle {
	font-size: 13px;
	margin-left: 20px;
	font-weight: 400;
	color: #999;
}

.headerRight {
}

.module-top {
	width: 100%;
	height: 54px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-bottom: 1px solid #e8e8e8;

	// .module-top_body {
	//   width: 100%;
	// }

	.top-title {
		flex: 1;
		height: 100%;
		line-height: 54px;
		display: flex;

		.iconfont {
			color: #c6c6c6;
			font-size: 16px;
			margin-left: 6px;
			font-weight: normal;
		}
	}

	.top-detail {
		font-size: 14px;
		color: #5aa0ff;
		font-weight: normal;
		user-select: none;
		cursor: pointer;
	}

	.top-smalldetail {
		font-size: 13px;
		color: #5aa0ff;
		font-weight: normal;
		user-select: none;
		cursor: pointer;
	}

	&.noborder {
		border: none;
	}
}

.top-detail {
	font-size: 14px;
	color: #5aa0ff;
	font-weight: normal;
	user-select: none;
	cursor: pointer;
}
</style>
